import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import Icon from '../AppIcon';
import { colataPermessi } from '../../lib/services/colataService';

/**
 * Permessi dell'utente su Colata, letti una sola volta da colata_permessi() (stessa fonte dell'RLS).
 *   leggere  : cco-admin, gru-admin, Owner
 *   scrivere : cco-admin, Owner   (gru-admin = "Sola lettura")
 * Finché non sono caricati: scrivere = false (i comandi di scrittura non compaiono).
 */
const StatoIniziale = { leggere: false, scrivere: false, ruolo: null, loading: true };
const ColataPermessiContext = createContext(StatoIniziale);

export const ColataPermessiProvider = ({ children }) => {
  const [stato, setStato] = useState(StatoIniziale);

  useEffect(() => {
    let annullato = false;
    colataPermessi()
      .then((p) => {
        if (annullato) return;
        setStato({
          leggere: Boolean(p?.leggere),
          scrivere: Boolean(p?.scrivere),
          ruolo: p?.ruolo ?? null,
          loading: false,
        });
      })
      .catch(() => {
        if (annullato) return;
        // in caso di errore si resta in sola lettura: la scrittura la decide comunque il database
        setStato({ leggere: false, scrivere: false, ruolo: null, loading: false });
      });
    return () => { annullato = true; };
  }, []);

  const valore = useMemo(() => stato, [stato]);
  return <ColataPermessiContext.Provider value={valore}>{children}</ColataPermessiContext.Provider>;
};

export const useColataPermessi = () => useContext(ColataPermessiContext);

/** Oggetto "Sola lettura" per l'intestazione delle pagine (non appare mentre i permessi si caricano). */
export const BadgeSolaLettura = () => {
  const { leggere, scrivere, loading } = useColataPermessi();
  if (loading || !leggere || scrivere) return null;
  return (
    <div
      className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-amber-500/10 border border-amber-500/30 text-amber-500 shadow-sm"
      title="Puoi consultare i dati ma non modificarli"
    >
      <Icon name="Eye" size={16} />
      <span className="text-[10px] font-black uppercase tracking-widest">Sola lettura</span>
    </div>
  );
};
